import React from 'react';


const SvgRoller = ({ ...props }) => (
  <svg width="540" height="300" viewBox="0 0 540 300" fill="none" {...props}>
    <path
      d="M368.48 179.616H219.242v-12.949h136.289V0h140.391v66.154h-12.949V13.077H368.48v166.539z"
      fill="#F1945F"
    />
    <path
      d="M27.18 181.155c-3.846 0-7.05-3.206-7.05-7.052 0-3.846 3.204-7.051 7.05-7.051a7.031 7.031 0 017.053 7.051c-.129 3.846-3.206 7.052-7.052 7.052zm1.54-35.77v.257C12.82 145.898 0 158.975 0 175.001c0 16.025 12.821 28.974 28.72 29.359v.641h247.704v-59.616H28.719z"
      fill="#F1945F"
    />
    <path d="M539.129 299.616h-98.338V52.051h98.338v247.565z" fill="#fff" />
  </svg>
);

export default SvgRoller;
